import { PressReleaseEntity, PressReleaseLight } from '@finance-lab/utils/types'
import ApiBase from './Api'

export class PressReleaseApi extends ApiBase {
    findById(id: string): Promise<PressReleaseEntity> {
        return this._getRequest(`/press-releases/${id}`)
    }

    findByCompanyId(companyId: string): Promise<PressReleaseLight[]> {
        return this._getRequest(`/press-releases?companyId=${companyId}`)
    }
}
